<template>
	<el-dialog :title="uploadTitle" :visible.sync="visible" :before-close='uploadStateClose' width="20%">
		<div style="display: inline-block;margin-right: 10px;font-size: 16px;font-weight: bold;">供应商:</div>
		<el-select v-model="value" clearable placeholder="请选择">
			<el-option v-for="item in options" :key="item.supplier_id" :label="item.supplier_name" :value="item.supplier_id">
			</el-option>
		</el-select>
		<span slot="footer" class="dialog-footer">
			<el-button type="primary" @click="handleUpload">{{uploadTitle}}</el-button>
		</span>
	</el-dialog>
</template>
<script>
	import axios from 'axios';
	export default {
		props: {
			uploadState: { //显示状态
				default: false
			},
			id: {
				default: ''
			},
			uploadData: {
				default: {}
			},
			uploadType: {
				default: 0
			},
			uploadTitle: {
				default: ''
			}
		},
		data() {
			return {
				visible: true,
				value:'',
				options:[]
			};
		},
		created() {
			console.log(this.uploadData.supplier_list)
			this.options = [...this.uploadData.supplier_list]
		},
		methods: {
			//向父组件发射关闭弹框
			uploadStateClose(done) {
				done()
				this.$emit("closeOn", false);
			},
			//下载按钮
			handleUpload(){
				if(this.value == ''){
					this.$message({
						message:'请选择供应商',
						type:'warning'
					})
					return
				}
				if(this.uploadType == 1){
					axios.get(process.env.VUE_APP_caigou +'api/Procure/UpLoadInspection',{
						params:{
							id:this.id,
							supplier_id:this.value
						},
						responseType: 'blob'
					}).then(response => {
						// console.log(response)
							var href = window.URL.createObjectURL(response.data); //创建下载的链接
							var downloadElement = document.createElement('a');
							downloadElement.href = href;
							downloadElement.download = '验货单导出.xlsx';
							document.body.appendChild(downloadElement);
							downloadElement.click(); //点击下载
							document.body.removeChild(downloadElement); //下载完成移除元素
							window.URL.revokeObjectURL(href); //释放掉blob对象
					}).catch(err => {
							console.log(err)
					})
				}else if(this.uploadType == 2){
					axios.get(process.env.VUE_APP_caigou +'api/Procure/UpLoadInvoice',{
						params:{
							id:this.id,
							supplier_id:this.value
						},
						responseType: 'blob'
					}).then(response => {
						// console.log(response)
							var href = window.URL.createObjectURL(response.data); //创建下载的链接
							var downloadElement = document.createElement('a');
							downloadElement.href = href;
							downloadElement.download = '报货单导出.xlsx';
							document.body.appendChild(downloadElement);
							downloadElement.click(); //点击下载
							document.body.removeChild(downloadElement); //下载完成移除元素
							window.URL.revokeObjectURL(href); //释放掉blob对象
					}).catch(err => {
							console.log(err)
					})
				}
			}
		},
		watch: {
			// 监视状态发生改变
			uploadState() {
				this.visible = this.uploadState;
			},
		}
	};
</script>
